import type { PdfiumApi, PdfiumTypeMap } from "@pdfking/pdfium-wrap"
import { UrlLoad } from "@pdfking/compatibility"
import { PSOcoated_v3_small as DefaultICC } from "@pdfking/icc"
import { PdfiumExports as E } from "@pdfking/pdfium-wrap"

export type IccProfile = {
  readonly destroy: () => Promise<void>
  readonly handle: PdfiumTypeMap["PDFKING_ICC_TRANSFORM"]
}

export const LoadIccProfile = async (
  api: PdfiumApi,
  iccUrl?: string
): Promise<IccProfile> => {
  const response = await UrlLoad(
    iccUrl ?? DefaultICC,
    "application/octet-stream"
  )
  const iccBytes = new Uint8Array(await response.arrayBuffer())
  const { free: freeIcc, pointer: iccPtr } = api.writeBytes(iccBytes)

  try {
    const handle = await api.call(
      E.PDFKING_ICC_CreateTransform,
      iccPtr,
      iccBytes.length
    )
    return {
      destroy: () => api.call(E.PDFKING_ICC_DestroyTransform, handle),
      handle,
    }
  } finally {
    freeIcc()
  }
}
